import { Chip } from '@material-ui/core';
import { Status as HoseStatus } from '../../../enums/HoseEnum';

const HoseStatusChip = ({hose, classes}) => {
  let statusColor = null;

  switch (hose.getStatus()) {
    case HoseStatus.OUT_OF_SERVICE:
      statusColor = classes.warning;
      break;
    case HoseStatus.IN_SERVICE:
      statusColor = classes.success;
      break;
    case HoseStatus.DECOMMISSIONED:
      statusColor = classes.danger;
      break;
  }

  return <Chip color="primary" label={HoseStatus.toDisplayValue(hose.getStatus())} className={statusColor}/>
}

export default HoseStatusChip;